const tripReports = {
  tripsPaxReports: {
    tripId: 'Fahrt-ID',
    date: 'Datum',
    status: 'Status',
    statuses: 'Status',
    drivers: 'Fahrer',
    vehicles: 'Fahrzeuge',
    from: 'Von',
    to: 'Bis',
    passengers: 'Fahrgäste',
    statusDone: 'Erledigt',
    statusNew: 'Neu',
    statusCanceled: 'Storniert',
    statusInRoute: 'Unterwegs',
    average: 'Durchschnitt',
    trips: 'Fahrten',
    tripsPassengersSummary: 'Zusammenfassung der Fahrten/Fahrgäste',
  },
};

export default tripReports;
